module.exports = __webpack_public_path__ + "img/blue_163.77e05e35.png";